/**
 * @voltxampere/ui — 7408 quad AND TTL variant (Sprint 41-4)
 *
 * Reference: TI SN5408. Engine zero-diff invariant honored.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const logic7408 = {
    id: "7408",
    nameTr: "7408 (4'lü AND, DIP-14)",
    nameEn: "7408 (Quad AND, DIP-14)",
    shortcut: "U",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "7408",
    schemaType: "digital-gate",
    defaultParams: {
        gateFunction: "AND",
        vHigh: 2.4,
        vLow: 0.4,
        threshold: 1.4,
        propagationDelay: 10e-9,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=logic-7408.js.map